import $ from 'jquery';

function showErrors(component, form, modelErrors) {
  const vvErrors = component.errors;

  const summaryErrors = [];
  for (let key in modelErrors) {
    if (modelErrors.hasOwnProperty(key)) {
      var name = key.replace(/([\\!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g, '\\$1');
      if ($(form).find("[name='" + name + "']").length === 0) {
        summaryErrors.push(modelErrors[key]);
        delete modelErrors[key];
      }
    }
  }

  summaryErrors.forEach(e => [].concat(...e).forEach(m => vvErrors.add('.', m)));
  for (let key in modelErrors) {
    [].concat(...modelErrors[key]).forEach(m => vvErrors.add(key, m));
  }
}

export default {
  methods: {
    hasErrorOn: function (name) {
      return this.errors.has(name) && this.fields[name].pristine;
    },

    validateResponse: function (form, response) {
      if (response && response.status === 400) {
        showErrors(this, form, response.data);
        return true;
      }
      return false;
    },

    hasAntiforgeryToken: function () {
      let match = document.cookie.match(new RegExp('XSRF-TOKEN' + '=([^;]+)'));
      return match;
    },

    showErrorSummary: function (form, data) {
      showErrors(this, form, data);
    }
  },
};
